import Image from 'components/Image';
import React from 'react';

const CSS = require('./HostImageCards.module.scss');

const IMAGE_OPTIONS = {
  width: 64,
  height: 80,
  gravity: 'faces',
};

interface HostImageCardsProps {
  images: string[];
}

function HostImageCards({ images }: HostImageCardsProps) {
  if (!images || images.length === 0) {
    return <figure className={CSS.HostImageCards} />;
  }
  return (
    <figure className={CSS.HostImageCards}>
      {images.map((image, i) => (
        <Image
          src={image}
          options={IMAGE_OPTIONS}
          width={IMAGE_OPTIONS.width}
          height={IMAGE_OPTIONS.height}
          alt={`Withlocals host`}
          className={CSS.Image}
          key={`image-${i}`}
        />
      ))}
    </figure>
  );
}

export default HostImageCards;
